module.exports = __webpack_public_path__ + "img/1558493027.4bacaf2b.jpg";